import { Component, OnInit, ViewChild } from '@angular/core';
import { E5coreUiWorkHistoryBaseComponent } from './e5core-ui-work-history-base';
import { PageEvent, MatSort, MatPaginator } from '@angular/material';
import { HistoryOdataService } from '../../../services/history-odata.service';
import { Guid } from 'guid-typescript';
import { OdataMatTableDataSource } from './odata-mat-table-data-source';
import { WorkHistoryFrameModel } from '../../../models/work-history.model';

@Component({
  selector: 'e5core-ui-work-history-material',
  templateUrl: './e5core-ui-work-history-material.component.html',
  styleUrls: ['./e5core-ui-work-history-material.component.css']
})
export class E5coreUiWorkHistoryMaterialComponent extends E5coreUiWorkHistoryBaseComponent implements OnInit{

  displayedColumns: string[] = ['EventDate','EventUser','EventName','StatusName','Detail'];
  dataSource: OdataMatTableDataSource ;
  isLoading: boolean = true ;

  length = 0;
  pageSize = 10;
  pageSizeOptions: number[] ;

  // MatPaginator Output
  pageEvent: PageEvent;
  @ViewChild(MatSort) sort: MatSort;t
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private history : HistoryOdataService) {
    super() ;
  }

  ngOnInit() {
    this.pageSizeOptions = (this.pagesizes && this.pagesizes.length > 0) ? this.pagesizes : [5, 10, 25, 50];
    this.dataSource = new OdataMatTableDataSource(Guid.EMPTY, this.history); // this.history.getHistory(id, 0, 10) ;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.loadingEvents.subscribe(
      isLoading => {
        this.isLoading = isLoading ;
      }
    )

    this.workItem$.subscribe(
      wim => {
        this.dataSource.setWorkId(wim.workId) ;
      }
    )
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }

}
